import {action} from 'mobx';

import {udApi} from '@udemy/ud-api';

import {EnrolledCourses} from '../types/enrolledCourses';

export class UserEnrollmentStore {
    declare courses?: EnrolledCourses[];

    url(userId: string, organizationId: string, topicId: string) {
        return `organizations/${organizationId}/analytics/badge-user-activity/${userId}/topic/${topicId}/active-courses/`;
    }

    setCourses = (courses: EnrolledCourses[]) => {
        this.courses = courses;
    };

    getCourses = () => {
        return this.courses || [];
    };

    @action
    fetchResources = async (organizationId: string, userId: string, topicId: string) => {
        try {
            const response = await udApi.get(this.url(userId, organizationId, topicId));
            this.setCourses(response.data.results);
        } catch (error) {
            throw error;
        }
    };
}
